import { LeaderForm } from '@/modules/Dayoffs/components/Form/LeaderApproveForm'
import { DayOffResponse } from '@/modules/Dayoffs/types/response'
import { ModalProps } from '@/types/shared'
import { Dialog } from 'vnetwork-ui'
import { useTranslation } from 'react-i18next'

export interface LeaderConfirmModalProps extends ModalProps {
    dayOff: DayOffResponse
    refetch: () => void
}

const LeaderConfirmModal: React.FC<LeaderConfirmModalProps> = ({
    onClose,
    open,
    dayOff,
    refetch,
}) => {
    const { t } = useTranslation('dayoffs')
    return (
        <Dialog onClose={onClose} open={open} title={t('leader_confirm')}>
            <LeaderForm dayOff={dayOff} refetch={refetch} onClose={onClose} />
        </Dialog>
    )
}

export default LeaderConfirmModal
